export enum AiAlertAnomalyType {
    TYPE_CUMULATIVE_DURATION = 'TYPE_CUMULATIVE_DURATION',
    TYPE_INSTANCE_COUNT = 'TYPE_INSTANCE_COUNT',
    TYPE_INSTANCE_DURATION= 'TYPE_INSTANCE_DURATION'
}
